import React, {FC} from 'react';

import StepHasAdvisor from '../../../commons/FormsLibrary/steps/StepHasAdvisor';
import {useFormContext} from '../form';

const HasAdvisor: FC = () => {
  const {values, additionalProps, next, setValues} = useFormContext();

  return (
    <StepHasAdvisor
      hasAdvisor={values.hasAdvisor}
      hideStepIcon={additionalProps.hideStepIcon}
      setHasAdvisor={(hasAdvisor) => setValues({hasAdvisor})}
      next={next}
    />
  );
};

export default HasAdvisor;
